<template>
  <div class="cd-section" id="Jipvio_About">
    <!--     *********     HEADER 1, 서비스소개 페이지 메인 헤더      *********      -->
    <div class="header-1">
      <div class="page-header header-filter">
        <div class="page-header-image" style="background: #6d4bde">
          <img
            class="about_bg"
            src="/img/jipvio_about_header_bg.png"
            alt="서비스소개 배경이미지"
          />
        </div>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 col-sm-10 mr-auto text-left">
                <h1
                  class="title pb-20"
                  style="text-shadow: 2px 4px rgba(0, 0, 0, 0.3)"
                >
                  가장 투명한<br />중개 플랫폼,
                  <span style="font-weight: bold; font-size: 1.2em"
                    >집비오</span
                  >
                </h1>
                <h4
                  class="description"
                  style="
                    text-shadow: 1px 1px rgba(0, 0, 0, 0.3);
                    font-weight: 500;
                  "
                >
                  #비대면 #1대1_전속중개 #공공데이터 #허위매물원천차단
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div id="about-contents1">
          <div class="container">
            <div class="row" style="height: 100%">
              <div class="col-lg-12 col-md-12 row ml-auto mr-auto px-0">
                <div class="about-boxes col-md-3 col-4 m-auto px-0">
                  <h3 class="title jipvio-text-center">전속중개계약</h3>
                  <div>
                    <img src="/img/svg/shake1.svg" alt="전속중개계약" />
                  </div>
                </div>
                <div class="jvo-circle jvo-circle1">
                  <img src="/img/svg/plus.svg" alt="더하기" />
                </div>
                <div class="about-boxes col-md-3 col-4 m-auto px-0">
                  <h3 class="title jipvio-text-center">공공API 활용</h3>
                  <div>
                    <img src="/img/svg/cloud_api_bg.svg" alt="공공API 활용" />
                  </div>
                </div>
                <div class="jvo-circle jvo-circle2">
                  <img src="/img/svg/equals.svg" alt="같다" />
                </div>
                <div class="about-boxes col-md-3 col-4 m-auto px-0">
                  <h3 class="title jipvio-text-center">허위매물 원천차단</h3>
                  <div>
                    <img
                      id="ghost_home"
                      src="/img/svg/ghost_home_line1.svg"
                      alt="허위매물 원천차단"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="about-header1">
          <!-- <h2 class="title jipvio-text-center">허위매물 차단 시스템 구현</h2> -->
        </div>
      </div>
    </div>
    <!--     *********    END HEADER 1      *********      -->
    <!--     *********     FEATURES 1, 허위매물 차단시스템 설명      *********      -->
    <div class="features-1">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto pb-50">
            <h2 class="title jipvio-text-center">허위매물 차단 시스템 구현</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <img
              src="/img/svg/No_Fake.svg"
              style="width: 50%; margin: 0 auto; display: block"
              alt="허위매물 차단시스템"
            />
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES 1      *********      -->
    <!--     *********     FEATURES 1, 허위매물 설명     *********      -->
    <div
      class="features-1"
      style="background-color: #f8f6fc; padding-top: 0; padding-bottom: 0"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <div class="info info-hover" style="padding-top: 10px">
              <h4 class="info-title">낚시매물</h4>
              <img
                src="/img/svg/fishing_prop.svg"
                style="width: 50%; margin: 0 auto; display: block"
                alt="낚시매물"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover" style="padding-top: 10px">
              <h4 class="info-title">허위매물</h4>
              <img
                src="/img/svg/fake_property.svg"
                style="width: 50%; margin: 0 auto; display: block"
                alt="허위매물"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="info info-hover" style="padding-top: 10px">
              <h4 class="info-title">중복매물</h4>
              <img
                src="/img/svg/copy_props.svg"
                style="width: 50%; margin: 0 auto; display: block"
                alt="중복매물"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES 1      *********      -->
    <!-- 비대면 전속중개 서비스 설명 -->
    <!--     *********     FEATURES 7    *********      -->
    <div class="features-7 section-image" style="background-color: #ffffff">
      <div class="col-md-8 mr-auto ml-auto text-center pb-20">
        <h2 class="title" style="color: #333333">비대면 전속중개 서비스</h2>
      </div>
      <div class="container-fluid pt-20">
        <div class="row">
          <div class="col-lg-6 px-0 stickyy jipvio-m-hide">
            <div class="col-sm-12">
              <div class="info info-horizontal">
                <div class="icon">
                  <div class="title-left-bar bar-focus"></div>
                </div>
                <div class="description">
                  <h4 class="info-title title-focus">1대1 전속중개계약</h4>
                  <p class="description">
                    한 명의 의뢰인이 한 명의 공인중개사에게만 매물을 의뢰하는
                    전속중개계약만을 체결합니다. 허위매물을 원천차단할 수
                    있습니다.
                  </p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon">
                  <div class="title-left-bar"></div>
                </div>
                <div class="description desc-noexpose">
                  <h4 class="info-title">공공데이터 활용</h4>
                  <p class="description">
                    정부에서 제공하는 공공데이터(건축물대장, 실거래가 등)를
                    활용하여 정확한 매물의 정보를 확인하실 수 있습니다.
                  </p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon">
                  <div class="title-left-bar"></div>
                </div>
                <div class="description desc-noexpose">
                  <h4 class="info-title">다양한 매물정보</h4>
                  <p class="description">
                    360VR, 열화상, 일반이미지 등 다양한 매물정보를 제공합니다.
                    온라인으로 정확한 정보를 확인해보세요!
                  </p>
                </div>
              </div>
              <div class="info info-horizontal">
                <div class="icon">
                  <div class="title-left-bar"></div>
                </div>
                <div class="description desc-noexpose">
                  <h4 class="info-title">동네정보소개 콘텐츠</h4>
                  <p class="description">
                    그동안 매물 정보만 보셨나요? 주변 동네정보를 소개하는
                    콘텐츠를 통해 새로운 동네에서의 삶을 미리 경험해보세요!
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="image-contaianer">
              <img
                v-lazy="'/img/svg/1vs1_contract.svg'"
                alt="전속중개계약 체결"
              />
              <div class="m-description jipvio-m-show">
                <h3 class="info-title title-focus">1대1 전속중개계약</h3>
                <p class="description">
                  한 명의 의뢰인이 한 명의 공인중개사에게만 매물을 의뢰하는
                  전속중개계약만을 체결합니다.<br />
                  허위매물을 원천차단할 수 있습니다.
                </p>
              </div>
            </div>
            <div class="image-contaianer">
              <img
                v-lazy="'/img/svg/info_API.svg'"
                alt="공공데이터 활용, 데이터 가공 및 처리"
              />
              <div class="m-description jipvio-m-show">
                <h3 class="info-title title-focus">공공데이터 활용</h3>
                <p class="description">
                  정부에서 제공하는 공공데이터(건축물대장, 실거래가 등)를
                  활용하여<br />
                  정확한 매물의 정보를 확인하실 수 있습니다.
                </p>
              </div>
            </div>
            <div class="image-contaianer">
              <img
                v-lazy="'/img/svg/360_vr_photo.svg'"
                alt="360VR, 열화상, 일반 이미지 일러스트"
              />
              <div class="m-description jipvio-m-show">
                <h3 class="info-title title-focus">다양한 매물정보</h3>
                <p class="description">
                  360VR, 열화상, 일반이미지 등 다양한 매물정보를 제공합니다.<br />
                  온라인으로 정확한 정보를 확인해보세요!
                </p>
              </div>
            </div>
            <div class="image-contaianer">
              <img
                v-lazy="'/img/svg/introduce_video.svg'"
                alt="동네정보소개 콘텐츠"
              />
              <div class="m-description jipvio-m-show">
                <h3 class="info-title title-focus">동네정보소개 콘텐츠</h3>
                <p class="description" style="margin-top: -10vh">
                  그동안 매물 정보만 보셨나요?<br />주변 동네정보를 소개하는
                  콘텐츠를 통해 새로운 동네에서의 삶을 미리 경험해보세요!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--     *********    END FEATURES 7      *********      -->
  </div>
</template>
<script>
import { FormGroupInput, Button } from "@/components";
import { Carousel, CarouselItem } from "element-ui";
export default {
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem,
  },
};
</script>
<style scoped>
#Jipvio_About .features-7 .container-fluid {

}
#Jipvio_About .features-7 .container-fluid .row {
  position: relative;
  overflow-y: scroll;
}
#Jipvio_About .features-7 .container-fluid .row::-webkit-scrollbar {
  background-color: #ffffff;
  width: 12px; /*height는 가로축 스크롤바 길이, width는 세로축*/
}
#Jipvio_About .features-7 .container-fluid .row::-webkit-scrollbar-track-piece {
  width: 80%;
}
#Jipvio_About .features-7 .container-fluid .row::-webkit-scrollbar-thumb {
  /* display: none;  Chrome, Safari, Opera*/
  background-color: #5a2fca;
  width: 10px; /*height는 가로축 스크롤바 길이, width는 세로축*/
  border-radius: 10px;
  padding: 3px 0;
  background-clip: padding-box;
  border: 3px solid transparent;
}
#Jipvio_About .features-7 .container-fluid .row::-webkit-scrollbar-track {
  /* display: none;  Chrome, Safari, Opera*/
  background-color: #e0e0e000;
  border-radius: 15px;
  box-shadow: inset 0 0 5px #ffffff;
}
.cd-section#Jipvio_About {
  cursor: url("ghost_home.png"), auto;
}
#Jipvio_About .page-header .content-center {
  top: 40%;
}
#Jipvio_About .page-header img.about_bg {
  display: block;
  position: absolute;
  right: 0;
  bottom: 155px;
  width: 70vh;
}
#about-contents1 {
  width: 100%;
  height: 30vh;
  position: absolute;
  top: 66%;
  z-index: 10;
  margin: 0;
}
#about-contents1 > div:nth-child(1) {
  height: 100%;
}
#about-contents1 > div > div > div {
  height: 100%;
}
#about-contents1 div.about-boxes {
  height: 100%;
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 8px 6.02px 0.98px rgba(0, 0, 0, 0.3);
}
#about-contents1 div.about-boxes h3 {
  color: #3f52ae;
  height: 20%;
}
#about-contents1 div.about-boxes div {
  width: 100%;
  height: 80%;
  position: relative;
}
#about-contents1 div.about-boxes img {
  width: 50%;
  display: block;
  margin: 0 auto;
  position: absolute;
  bottom: 6vh;
  left: 25%;
}
div.about-boxes img#ghost_home {
  width: 60%;
  left: 20%;
  bottom: 20px;
}
#about-contents1 div.jvo-circle {
  width: 60px;
  height: 60px;
  border-radius: 100px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 8px 6.02px 0.98px rgba(0, 0, 0, 0.3);
  position: relative;
  top: 40%;
  z-index: 10;
}
#about-contents1 div.jvo-circle img {
  width: 60%;
  margin-top: 20%;
  margin-left: 20%;
}
#about-header1 {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 19vh;
  background-color: #ffffff;
}
#about-header1 h2 {
  position: absolute;
  bottom: 10%;
  width: 100%;
  color: #333333;
}
#Jipvio_About .features-7:after {
  background-color: #ffffff;
}
#Jipvio_About .features-7 h4,
#Jipvio_About .features-7 p {
  color: #333333;
}
#Jipvio_About div.desc-noexpose h4,
#Jipvio_About div.desc-noexpose p {
  color: #9f9f9f;
}
#Jipvio_About .title-left-bar {
  width: 7px;
  height: 30px;
  background-color: #9f9f9f;
}
#Jipvio_About .title-left-bar.bar-focus {
  background-color: #754edd;
}

#Jipvio_About .title-focus {
  color: #5a2fca !important;
  font-weight: 500;
}
#Jipvio_About .title-focus ~ p {
  font-weight: 400;
}
#Jipvio_About .image-contaianer {
  height: 100%;
  width: 100%;
}
#Jipvio_About .image-contaianer img {
  display: block;
  width: 80%;
  margin: 0 auto;
}
div.m-description {
  width: 80%;
  margin: 0 auto;
  text-align: center;
}
div.m-description p {
  font-size: 1.5em;
}
@media screen and (max-width: 1024px) {
  #about-contents1 div.about-boxes img {
    bottom: 4vh;
  }
  div.about-boxes img#ghost_home {
    bottom: 3vh;
  }
  #about-contents1 div.about-boxes h3 {
  color: #3f52ae;
  height: 20%;
  letter-spacing: -0.9px;
  font-size: 1.2rem;
}
}
@media screen and (min-width: 992px) {
  #Jipvio_About {
    font-size: 14px;
  }
  #Jipvio_About .image-contaianer {
    position: relative;
    height: 100%;
    width: 100%;
  }
  #Jipvio_About .image-contaianer img {
    display: block;
    width: 80%;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 991px) {
  #Jipvio_About {
    font-size: 12px;
  }
  #about-contents1 {
    height: 22vh;
    top: 69%;
  }
}
@media screen and (max-width: 768px) {
  #Jipvio_About {
    font-size: 10px;
  }
  #Jipvio_About .page-header img {
    width: 50vh;
  }
  #about-contents1 {
    height: 20vh;
    top: 70%;
  }
}
@media screen and (max-width: 767px) {
  #about-contents1 div.jvo-circle {
    position: absolute;
    top: 40%;
    z-index: 10;
  }
  #about-contents1 div.jvo-circle1 {
    left: 150px;
  }
  #about-contents1 div.jvo-circle2 {
    right: 150px;
  }
}
@media screen and (max-width: 576px) {
  #Jipvio_About {
    font-size: 10px;
  }
  #about-contents1 div.jvo-circle {
    width: 45px;
    height: 45px;
  }
  #about-contents1 div.jvo-circle1 {
    left: 29vw;
  }
  #about-contents1 div.jvo-circle2 {
    right: 29vw;
  }
  #about-contents1 {
    height: 20vh;
    top: 68%;
  }
  #about-contents1 div.about-boxes h3 {
    color: #3f52ae;
    height: 20%;
    padding-top: 3vh;
  }
  #about-contents1 div.about-boxes div {
    width: 100%;
    height: 80%;
    position: relative;
  }
  #about-contents1 div.about-boxes img {
    width: 50%;
    display: block;
    margin: 0 auto;
    position: absolute;
    bottom: 4vh;
    left: 25%;
  }
  div.about-boxes img#ghost_home {
    width: 60%;
    left: 20%;
    bottom: 2.5vh;
  }
}
@media screen and (max-width: 510px) {
  #about-contents1 div.jvo-circle1 {
    left: 28vw;
  }
  #about-contents1 div.jvo-circle2 {
    right: 28vw;
  }
}
</style>
